// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"cb93e936","63":"6cf65ff0","72":"3ae93f2a","89":"94af8310","180":"0ee41021","288":"c26415c1","393":"3a7a2299","429":"af9e7629","453":"697eeab8","476":"649278ee","509":"f903de88","520":"45e3b706","534":"e22208d8","716":"b0d0deff","840":"0064220b"}[chunkId] + ".chunk.js";
};